import AdminCrud from "@/components/admin/AdminCrud";

export default function AdminFaqs() {
  return (
    <AdminCrud
      title="FAQs"
      resource="faqs"
      defaultItem={{ question: "", answer: "", category: "General", order: 1 }}
      fields={[
        { key: "question", label: "Question" },
        { key: "answer", label: "Answer", type: "textarea", rows: 4 },
        { key: "category", label: "Category" },
        { key: "order", label: "Order", type: "number" },
      ]}
    />
  );
}
